import { useState } from 'react'
import { toast } from 'react-toastify';
import { IconCheck, IconCopy } from '@tabler/icons-react';
import { Button } from '@shared/ui/button/button';

/**
 * Унифицированная кнопка копирования в буфер обмена.
 * Инкапсулирует запись в clipboard, toast-уведомление и состояние «Скопировано».
 *
 * @param {string} text - что копировать
 * @param {string|JSX.Element} label - текст кнопки до копирования
 * @param {string|JSX.Element} copiedLabel - текст кнопки после копирования
 * @param {boolean} icon - показывать ли стандартную иконку копирования (слева)
 * @param {string} successMessage - текст toast при успехе
 * @param {number} resetTimeout - через сколько мс сбрасывать состояние «Скопировано»
 * @param {Function} onCopied - колбэк после успешного копирования
 * ...остальные пропсы передаются в Button (theme, size, className и т.д.)
 */
export const CopyButton = ({
	text,
	label = 'Скопировать',
	copiedLabel = 'Скопировано',
	icon = true,
	successMessage = 'Ссылка скопирована',
	resetTimeout = 2000,
	onCopied,
	lefticon,
	...props
}) => {
	const [isCopied, setIsCopied] = useState(false)

	const handleCopy = async () => {
		try {
			await navigator.clipboard.writeText(text)
			setIsCopied(true)
			toast.success(successMessage)
			onCopied?.()
			setTimeout(() => setIsCopied(false), resetTimeout)
		} catch (err) {
			console.error('Не удалось скопировать ссылку', err)
			toast.error('Не удалось скопировать ссылку')
		}
	}

	return (
		<Button
			{...props}
			onClick={handleCopy}
			label={isCopied ? copiedLabel : label}
			lefticon={icon ? (isCopied ? <IconCheck size={16} /> : <IconCopy size={16} />) : lefticon}
		/>
	)
}
